<template>
  <div class="page-wrap">
    <el-row>
      <el-col :span="4">
        <slideTab :tabList="tabList" @selectKey="getSelectKey"></slideTab>
      </el-col>
      <el-col :span="17" v-if="activeIndex === 'intro'">
          <md1></md1>
      </el-col>
      <el-col :span="17" v-if="activeIndex === 'mode'">
          <md2></md2>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import slideTab from "../components/slideTab.vue";
import md1 from "../assets/markdown/yuying.md";
import md2 from "../assets/markdown/jiekou.md";
export default {
  name: "Cooperation",
  components: {
    slideTab, md1, md2
  },
  data() {
    return {
      activeIndex: 'intro',
      tabList: [
        {
          text: "运营相关",
          name: "intro",
          children: []
        },
        {
          text: "接口相关",
          name: "mode",
          children: []
        }
      ]
    };
  },
  methods: {
    getSelectKey(key) {
        this.activeIndex = key
      console.log(key);
    }
  }
};
</script>
<style lang="scss">
</style>
<style lang="scss" scoped>
.cooperation {
  // background: url("../assets/images/Back-cooperation.jpg") no-repeat center
  //   center;
  // background-size: 100% 100%;
  min-height: 100vh;
  padding: 80px;
}
.qa-btn {
  padding-top: 30px;
  a {
    display: block;
    border: 1px solid rgb(7, 7, 132);
    padding: 10px 0;
    width: 120px;
    text-align: center;
    border-radius: 4px;
    color: rgb(7, 7, 132);
  }
}
</style>
